










import { Component, mixins } from '@niknevis/vue-modules'
import TesTableRow from '@/modules/common/tes-table/mixins/TesTableRow.vue'
import TesTr from '@/modules/common/tes-table/components/shared/TesTr.vue'
import TesTd from '@/modules/common/tes-table/components/shared/TesTd.vue'
import { InjectReactive } from 'vue-property-decorator'
import DateTooltipped from '@/modules/shared/components/shared/utils/DateTooltipped.vue'
import BaseTooltip from '@/modules/shared/components/shared/kit/BaseTooltip.vue'
import TextEllipsis from '@/modules/shared/components/shared/utils/TextEllipsisOld.vue'
import { FaqCollectionType, FaqCollectionWithModel } from '@/modules/faq/models/faq-collection.model'
import FaqTypeView from '@/modules/faq/components/shared/FaqTypeView.vue'
import AdminFaqActions from '@/modules/faq/components/admin/table/AdminFaqActions.vue'

@Component({
  components: {
    TextEllipsis,
    TesTr,
    TesTd,
    DateTooltipped,
    BaseTooltip
  }
})
export default class AdminFaqTableRow extends mixins<TesTableRow>(TesTableRow) {

  @InjectReactive()
  faqs!: FaqCollectionType

  get fixedData(): FaqCollectionWithModel {
    return {
      types: this.faqs.types
    }
  }

  columnComponents = {
    type: {
      component: FaqTypeView,
      handler: (value, row, withData) => ({ type: row.type, types: withData.types })
    },
    question: {
      component: TextEllipsis,
      handler: (value, row) => ({ text: row.question })
    },
    answer: {
      component: TextEllipsis,
      handler: (value, row) => ({ text: row.answer })
    },
    created_at: {
      component: DateTooltipped,
      handler: (value) => ({ isoDate: value })
    },
    updated_at: {
      component: DateTooltipped,
      handler: (value) => ({ isoDate: value })
    },
    actions: {
      component: AdminFaqActions,
      handler: (value, row, withData) => ({ faq: row, withData: withData })
    }
  }

}
